import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "side-panel__container" }

import pigeon from '../../utilities/js/pigeon/pigeon';
  import {onMounted, watch} from 'vue';
  import {FocusTrap} from 'focus-trap-vue';

  
export default /*@__PURE__*/_defineComponent({
  ...{
    inheritAttrs: false
  },
  __name: 'SidePanel',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ['closeSidePanel'],
  setup(__props: any, { emit: __emit }) {

  

  const props = __props;

  const emits = __emit;

  const close = () => {
    emits('closeSidePanel');
  }

  onMounted(() => {
    pigeon.subscribe('pageoverlay:click', () => {
      close();
    });

    window.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        close();
      }
    });

    if (props.isVisible) {
      handlePageOverlay(true);
    }
  });

  watch(() => props.isVisible, () => {
    handlePageOverlay(props.isVisible);
    handleFocus(props.isVisible);
  });

  function handlePageOverlay(sidePanelActive: boolean) {
    if (sidePanelActive) {
      pigeon.publish('pageoverlay:show');
    } else {
      pigeon.publish('pageoverlay:hide');
    }
  }

  let lastFocusedElm: HTMLElement = null;
  function handleFocus(sidePanelActive: boolean) {
    if (sidePanelActive) {
      lastFocusedElm = document.activeElement as HTMLElement;
    }
    else {
      if (lastFocusedElm) {
        lastFocusedElm.focus();
      }
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_unref(FocusTrap), { active: _ctx.isVisible }, {
      default: _withCtx(() => [
        _createVNode(_Transition, { name: "side-panel-slide" }, {
          default: _withCtx(() => [
            (_ctx.isVisible)
              ? (_openBlock(), _createElementBlock("div", _mergeProps({
                  key: 0,
                  class: "side-panel"
                }, _ctx.$attrs, { role: "dialog" }), [
                  _createElementVNode("button", {
                    class: "side-panel__close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (close())),
                    "aria-label": _ctx.$t('global.close')
                  }, null, 8 /* PROPS */, _hoisted_1),
                  _cache[1] || (_cache[1] = _createTextVNode()),
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default")
                  ])
                ], 16 /* FULL_PROPS */))
              : _createCommentVNode("v-if", true)
          ]),
          _: 3 /* FORWARDED */
        })
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["active"])
  ]))
}
}

})